import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import CustomSelectInput from "../../components/common/CustomSelectInput";
import { NotificationManager } from "../../components/common/react-notifications";
import _axios from "../../libs/axios";
import { debounce, isEqual } from "lodash";
import AppLocale from "../../config/lang";

const listImgs = props => {
  if (!props.isDisabled) {
    return (
      <div className="select-option fadeIn" onClick={props.innerProps.onClick}>
        <div className="left">
          <img alt="Profile" src={props.data.img ? props.data.img : require("../../assets/img/user.png")} onError={(e)=>{e.target.onerror = null; e.target.src=require("../../assets/img/user.png")}}/>
        </div>
        <div className="center">
          <div className="name">{props.data.label}</div>
          <div className="desc">{props.data.desc}</div>
        </div>
      </div>
    )
  } else return null
}

const listIcons = props => {
  if (!props.isDisabled) {
    return (
      <div className="select-option fadeIn" onClick={props.innerProps.onClick}>
        <div className="left">
          <i className={`${props.data.value} h4`}></i>
        </div>
        <div className="center">
          <div>{props.data.label}</div>
        </div>
      </div>
    )
  } else return null
}

/*
const Menu = (props) => {
  console.log(props)
  if (!props.isDisabled){
    return (
      <div>
        ddddd
      </div>
    )
  } else return null
}
*/
  
class SelectCustom extends Component {
  mapItems = (items = [], locale = this.props.locale) => {
    const L = AppLocale[locale].messages
    return items.map(item => ({ ...item, label: L[item.label]?? item.label }))
  }

  constructor(props) {
    super(props)
    let items = []
    if (props.listInLocalStorage) {
      let lsi = localStorage.getItem(props.listInLocalStorage.name)
      if (lsi) {
        lsi = JSON.parse(lsi)
        const  list = lsi[props.listInLocalStorage.listName]?? []
        items = list.map(item => item = {value: item.id, label: item.name})
      }
    }
    this.state = {
      items: props.items ? this.mapItems(props.items, props.locale) : items,
      filter: null,
      loading: false
    }
    // default value {value: 1, label: ''}
    // default value for multiSelection [{id: 1, name: ''}, ...]
    let v = (() => {
      let r = null
      if (props.value !== null && props.value !== undefined && !props.isMulti) return props.value
      else if (props.value !== null && props.value !== undefined && props.items) return props.items.find((e) => { return e.value === props.value })
      return r
    })()
    this.state[props.name] = v
  }

  componentDidMount() {
    const { name, value, onChange, setOutput, getValueLabelOfFieldSelect } = this.props
    if (Array.isArray(value)) {
      // console.log(value)
      let v = []
      value.forEach(e => { v.push({ value: e.ID, label: e.name }) })
      this.setState({ [name]: v, items: [] }, () => {
        onChange(setOutput ? setOutput(v) : v.map(m => m.value))
      })
    } else {
      // console.log(value)
      let v = null
      v = this.state.items.find(item => item.value === value)
      if (!v && value) v = value
      this.setState({ [name]: v }, () => {
        onChange(setOutput ? setOutput(v) : (v ? v.value : null))
        if (getValueLabelOfFieldSelect && v) process.nextTick(() => { getValueLabelOfFieldSelect({[name]: {value: v.value, label: v.label}}) })
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { name, value, onChange, setOutput, path, parentValue, items, locale, isMulti } = this.props
    if (prevProps.value !== value && (value === undefined || value === null)) {
      this.setState({ [name]: null }, () => { /* console.log('cambio'); */ if(path) this.setState({items: []}) })
    } else if (
      prevProps.value !== value &&
      (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') &&
      this.state.items.length > 0
    ) {
      const select = this.state.items.find(item => item.value === value)
      this.setState({ [name]: {value: value, label: select?.label ?? null} })
    } else if (typeof value === 'object' && (this.state[name] === undefined || this.state[name] === null) && !isEqual(prevProps.value, value)) {
      this.setState({ [name]: {value: value.value, label: value.label} }, () => {
        onChange(setOutput ? setOutput(value) : value)
      })
    }
    if (prevProps.parentValue !== parentValue) {
      if (path) this.setState({items: []})
    }

    if (!isEqual(prevProps.items, items) || prevProps.locale !== locale) {
      const mappedItems = items ? this.mapItems(items, locale) : []
      const selectedValue = this.state[name]?.value ?? value
      const selectedItem = (!isMulti && selectedValue !== undefined && selectedValue !== null)
        ? mappedItems.find(item => item.value === selectedValue)
        : null
      this.setState({
        items: mappedItems,
        ...(selectedItem ? { [name]: selectedItem } : {})
      })
    }
  }

  getData = (filter) => {
    const { path, ctx, remap, isMulti, name } = this.props
    if (!filter) {
      if (!path || this.state.items.length > 0) return
    }

    this.setState(({ items: [], loading: true }))
    filter = filter ? `&filterBy=name&filter=${filter}` : ""
    let fullPath = typeof path == "function" ? `${path(ctx)}${filter}` : `${path}${filter}`
    _axios
      .get(fullPath)
      .then(r => {
        if (remap) r = remap(r)
        if (r.status >= 0) {
          let items = []
          r.data.Results && r.data.Results.forEach(e => {
            items.push({ value: e.ID, label: e.name, img: e.img, desc: e.desc, original: e })
          })
          this.setState(({ items: items }), () => { })
          if (isMulti) this.setState({ [name]: this.state[name] })
        }
        this.setState({ loading: false })
        NotificationManager[r.status >= 0 ? "success" : "error"](r.msg, r.status >= 0 ? "" : "Opps", 5000, null, null, "outline")
      })
  }

  handleChange = selectedOption => {
    const { name, onChange, params, isMulti, setOutput, getValueLabelOfFieldSelect } = this.props
    this.setState({ [name]: selectedOption })
    if (selectedOption === null || selectedOption === undefined) onChange(selectedOption)
    else if (params) onChange({params: params, value: selectedOption.value})
    else if (setOutput) onChange(setOutput(selectedOption))
    else if (isMulti === true) onChange(selectedOption.map(m => m.value))
    else onChange(selectedOption.value)
    if (getValueLabelOfFieldSelect) getValueLabelOfFieldSelect({[name]: {value: selectedOption?.value, label: selectedOption?.label}})
  }

  handleFocus = e => {
    if (!this.props.onFocus) return
    this.props.onFocus({
      value: this.state[this.props.name],
      props: this.props.params
    })
  }

  handleBlur = e => {
    if (!this.props.onBlur) return
    this.props.onBlur({
      value: this.state[this.props.name],
      props: this.props.params
    })
  }

  handleInputChange = debounce((text) => { this.getData(text) }, 400);

  customize () {
    let r = {Input: CustomSelectInput}
    // r.Menu = Menu
    if (this.props.withImg) r.Option = listImgs
    if (this.props.withIcon) r.Option = listIcons
    return r
  }

  render() {
    const { locale } = this.props
    const L = AppLocale[locale].messages
    const { name, onMenuOpen, ctx, isMulti, id, searchOnline, isClearable, placeholder, disabled, tabIndex, filterOption} = this.props
    return (
      <Select
        className="react-select"
        classNamePrefix="react-select"
        name={name}
        value={this.state[name]}
        isSearchable={true}
        onMenuOpen={() => { onMenuOpen ? onMenuOpen(ctx, this, L) : this.getData() }}
        components={this.customize()}
        onChange={this.handleChange}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        options={this.state.items}
        isMulti={isMulti}
        id={`react-select-wrap-${name}`}
        inputId={id}
        onInputChange={searchOnline ? (e) => this.handleInputChange(e) : () => {}}
        isClearable={isClearable}
        clearValue={() => undefined}
        menuPlacement="auto"
        placeholder={this.state.loading ? "Cargando.." : placeholder}
        noOptionsMessage={() => this.state.loading ? "Cargando.." : "No hay items"}
        isDisabled={disabled}
        tabIndex={tabIndex}
        filterOption={filterOption}
        autoFocus={false}
        // closeMenuOnSelect={false}
      />
    )
  }
}
 
const mapStateToProps = ({ settings }) => {
  const { locale } = settings
  return { locale }
}

export default connect(mapStateToProps)(SelectCustom)